'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.configs = void 0;
var adapter_1 = require("../adapter");
var Configs = /** @class */ (function () {
    function Configs() {
    }
    /**
     * Gets the navigation items for the main menu depending
     * on device type and language.
     */
    Configs.prototype.getNavigation = function (type, lang) {
        var params = { type: type, lang: lang };
        return adapter_1.adapter.configs.getNavigation(params);
    };
    return Configs;
}());
exports.configs = new Configs();
